export default __webpack_public_path__ + "static/media/user.35027ab1.jpg";